import React, { useEffect } from "react";
import Cookies from "js-cookie";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Typography } from "@mui/material";

export default function RouteVerification() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const project = searchParams.get("project");

  useEffect(() => {
    if (project) {
      navigate(`/${project}/login`);
      window.location.reload();
      Cookies.set("test_engine_project", project, { expires: 7 });
    }
  }, [project]);

  return (
    <>
      <Typography variant="h4">Loading...</Typography>
    </>
  );
}
